import axios from '@/assets/utils/axios'

export function getList(params) {
  return axios.post('/en/admin/department', params)
}
export function handleAdd(params) {
  return axios.post('/en/admin/department/insert', params)
}
